import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { QrRead } from "../components/scan/QrRead";
import { InputAmount } from "../components/scan/InputAmount";
import { Confirm } from "../components/scan/Confirm";
import CustomAxios from "../utils/CustomAxios";

export const Scan = () => {
  const location = useLocation();
  const isTopup = location?.state?.isTopup ?? false;
  const isPaperQr = location?.state?.isPaperQr ?? false;

  const [issuerId, setIssuerId] = useState<string>(location?.state?.issuerId);
  const [issuerName, setIssuerName] = useState<string>(
    location?.state?.issuerName
  );
  const [issuerType, setIssuerType] = useState<string>("");
  const [isScanOpen, setIsScanOpen] = useState<boolean>(true);
  const [isInputAreaOpen, setIsInputAreaOpen] = useState<boolean>(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [inputAmount, setInputAmount] = useState<string>("");
  const [selectRate, setSelectRate] = useState<number>();

  const sendAlwaysQrRequest = () => {
    CustomAxios.post(`/issuer/${location?.state?.issuerId}/qr_request`, {
      number: location?.state?.number,
      solt: location?.state?.solt,
      type: "always",
    }).catch((err) => console.log(err));
  };

  // 紙QR店舗のページからの場合はスキャン画面をスキップする
  useEffect(() => {
    if (isPaperQr) {
      setIsScanOpen(false);
      setIsInputAreaOpen(true);
      setIssuerType(location?.state?.issuerType);
      setSelectRate(location?.state?.selectRate);
    }
  }, [isPaperQr]);

  return (
    <>
      {isScanOpen && (
        <QrRead
          setIssuerId={setIssuerId}
          setIssuerName={setIssuerName}
          setIssuerType={setIssuerType}
          setIsScanOpen={setIsScanOpen}
          setIsInputAreaOpen={setIsInputAreaOpen}
          setSelectRate={setSelectRate}
          sendAlwaysQrRequest={sendAlwaysQrRequest}
          isTopup={isTopup}
        />
      )}
      {isInputAreaOpen && (
        <InputAmount
          issuerName={issuerName}
          setIsInputAreaOpen={setIsInputAreaOpen}
          inputAmount={inputAmount}
          setInputAmount={setInputAmount}
          setIsConfirmOpen={setIsConfirmOpen}
          sendAlwaysQrRequest={sendAlwaysQrRequest}
          isTopup={isTopup}
        />
      )}
      {isConfirmOpen && (
        <Confirm
          issuerId={issuerId}
          issuerName={issuerName}
          issuerType={issuerType}
          setIsInputAreaOpen={setIsInputAreaOpen}
          setIsConfirmOpen={setIsConfirmOpen}
          inputAmount={inputAmount}
          selectRate={selectRate}
          setSelectRate={setSelectRate}
          isTopup={isTopup}
        />
      )}
    </>
  );
};
